/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitPaginatedEntityLookalikesResponse
 */
export interface MonitPaginatedEntityLookalikesResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityLookalikesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityLookalikesResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityLookalikesResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof MonitPaginatedEntityLookalikesResponse
     */
    results: Array<any>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityLookalikesResponse interface.
 */
export function instanceOfMonitPaginatedEntityLookalikesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function MonitPaginatedEntityLookalikesResponseFromJSON(json: any): MonitPaginatedEntityLookalikesResponse {
    return MonitPaginatedEntityLookalikesResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityLookalikesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityLookalikesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': json['results'],
    };
}

export function MonitPaginatedEntityLookalikesResponseToJSON(value?: MonitPaginatedEntityLookalikesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results,
    };
}

